export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9644.ef702a92.jpg";